var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('TheDebugBar',{attrs:{"set-as-app":!_vm.isImpersonating}}),(_vm.isAuthenticated)?_c('TheImpersonateBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }